import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mainComponent from './main.component';

const mainModule = angular
  .module('main', [uiRouter])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');
    $stateProvider.state('main', {
      abstract: true,
      component: 'main',
    });
  })
  .component('main', mainComponent).name;

export default mainModule;



// WEBPACK FOOTER //
// ./client/app/components/main/main.js